import { render } from "./GameBoard.vue?vue&type=template&id=65aa18d4"
import script from "./GameBoard.vue?vue&type=script&lang=js"
export * from "./GameBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__